export enum SupportedSteps {
  Confirmation = 'confirmation',
  TrackingIntegration = 'tracking',
  Driver = 'driver',
  TruckInfo = 'truck-info',
  AllSet = 'all-set',
}

type Step = {
  id: SupportedSteps
}

export function getStepIndexByStepId(step: SupportedSteps, steps: Array<Step>): number {
  return steps.findIndex(element => element.id === step)
}

export function getNextStep(currentStep: SupportedSteps, steps: Array<Step>): number {
  const index = getStepIndexByStepId(currentStep, steps)
  return index + 1
}
